import React from "react";
var __jsx = React.createElement;
var RadioCard = function RadioCard(_ref) {
  var id = _ref.id,
    name = _ref.name,
    value = _ref.value,
    checked = _ref.checked,
    onChange = _ref.onChange,
    title = _ref.title,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? "" : _ref$subtitle,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: "border border-gray-gainsboro border-solid rounded-lg p-4 cursor-pointer transition-all duration-200 hover:border-primary ".concat(checked ? 'border-primary bg-blue-50' : '', " ").concat(className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    id: id,
    name: name,
    value: value,
    checked: checked,
    onChange: onChange,
    className: "w-5 h-5 text-primary border-2 border-gray-300"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-1"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-neutral-90 text-sm font-bold leading-6"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "text-neutral-30 text-xs font-normal leading-4"
  }, subtitle))));
};
export default RadioCard;